class DateUtils {
  static forBackEnd (date) {
    if (moment.isMoment(date)) {
      return date.format('Y-MM-DD HH:mm:ss')
    }
    if (date) {
      return moment(date).format('Y-MM-DD HH:mm:ss')
    }
    return date
  }

  static calendarDateFormat (date, settings) {
    if (date) {
      return moment(date).format('MMMM DD [de] Y')
    }
    return date
  }

  static formatDateToString (date) {
    return date && moment(date).format('MMMM DD [de] Y')
  }

  static formatDateTimeToString (date) {
    return date && moment(date).format('MMMM DD [de] Y hh:mm:ss A')
  }

  /**
   * Los string del backend llegan en este formato: 2019-10-02 01:42:00
   */
  static backEndStringToDate (date) {
    let r = moment(date, 'Y-MM-DD HH:mm:ss', true)
    return r.isValid() ? r.toDate() : null
  }
}

export default DateUtils



// WEBPACK FOOTER //
// ./src/util/DateUtils.js